import * as API from './api'
import * as Types from './Types'

export function tryUpdateLaundryRules(
  token,
  communityId,
  laundryRulesId,
  postData
) {
  return dispatch => {
    dispatch({
      type: Types.UPDATE_LAUNDRY_RULES
    })

    API.updateLaundryRules(token, communityId, laundryRulesId, postData)
      .then(response => {
        dispatch({
          type: Types.UPDATE_LAUNDRY_RULES_SUCCESS,
          payload: response.data.data
        })
      })
      .catch(error => {
        let status = 500

        if (error.response && error.response.status) {
          status = error.response.status
        }

        dispatch({
          type: Types.UPDATE_LAUNDRY_RULES_FAILED,
          payload: status
        })
      })
  }
}



// WEBPACK FOOTER //
// ./src/components/actions/LaundryRules.js